// removed by extract-text-webpack-plugin
module.exports = {"container":"lyJZuMB","link":"_3SJNIPo","MyAccount":"_1HFECXU","MyOrders":"_3C_t5ox","ReturnsInformation":"vuqP4Lm","AList":"_131oI3K"};


//////////////////
// WEBPACK FOOTER
// ./template/components/Footer/MyAccountLinks/index.css
// module id = ./template/components/Footer/MyAccountLinks/index.css
// module chunks = client.sitechrome